import React, { useEffect } from "react";
import { Card, CardBody, Col, Form, Input, Label, Row } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { charactersWithSpaces } from "../../helpers/validations/regex";

const CertificateForm = ({
  certificateId,
  certificateData,
  selectedCertificateType,
  onSubmit,
}) => {
  console.log("CertificateForm props:", {
    certificateId,
    certificateData,
    selectedCertificateType,
  });

  const internshipSchema = Yup.object({
    recipientName: Yup.string()
      .required("Recipient name is required")
      .matches(charactersWithSpaces, "Only characters allowed"),
    // certificateName: Yup.string()
    //   .required("Certificate name is required")
    //   .matches(charactersWithSpaces, "Only characters allowed"),
    // companyName: Yup.string()
    //   .required("Company name is required")
    //   .matches(charactersWithSpaces, "Only characters allowed"),
    courseType: Yup.string()
      .required("Course type is required")
      .matches(charactersWithSpaces, "Only characters allowed"),
    startDate: Yup.date().required("Start date is required"),
    endDate: Yup.date()
      .required("End date is required")
      .min(Yup.ref("startDate"), "End date must be after start date"),
    duration: Yup.number()
      .positive("Duration must be positive")
      .integer("Duration must be an integer"),
    email: Yup.string().required("Email is required").email("Invalid email"),
    mobileNumber: Yup.string()
      .required("Mobile number is required")
      .test(
        "isValidPhone",
        "Invalid phone number",
        (v) => v && isValidPhoneNumber(v)
      ),
  });

  const appreciationAchievementSchema = Yup.object({
    recipientName: Yup.string()
      .required("Recipient name is required")
      .matches(charactersWithSpaces, "Only characters allowed"),
    // certificateName: Yup.string()
    //   .required("Certificate name is required")
    //   .matches(charactersWithSpaces, "Only characters allowed"),
    // companyName: Yup.string()
    //   .required("Company name is required")
    //   .matches(charactersWithSpaces, "Only characters allowed"),
    dept: Yup.string().required("Department is required"),
    issueDate: Yup.date().required("Issue date is required"),
    email: Yup.string().required("Email is required").email("Invalid email"),
    mobileNumber: Yup.string()
      .required("Mobile number is required")
      .test(
        "isValidPhone",
        "Invalid phone number",
        (v) => v && isValidPhoneNumber(v)
      ),
  });

  const hackathonSchema = Yup.object({
    recipientName: Yup.string()
      .required("Recipient name is required")
      .matches(charactersWithSpaces, "Only characters allowed"),
    // certificateName: Yup.string()
    //   .required("Certificate name is required")
    //   .matches(charactersWithSpaces, "Only characters allowed"),
    // companyName: Yup.string()
    //   .required("Company name is required")
    //   .matches(charactersWithSpaces, "Only characters allowed"),
    hackathonName: Yup.string()
      .required("Hackathon name is required")
      .matches(charactersWithSpaces, "Only characters allowed"),
    issueDate: Yup.date().required("Issue date is required"),
    email: Yup.string().required("Email is required").email("Invalid email"),
    mobileNumber: Yup.string()
      .required("Mobile number is required")
      .test(
        "isValidPhone",
        "Invalid phone number",
        (v) => v && isValidPhoneNumber(v)
      ),
  });

  const bestTeamSchema = Yup.object({
    teamName: Yup.string()
      .required("Team name is required")
      .matches(charactersWithSpaces, "Only characters allowed"),
    // certificateName: Yup.string()
    //   .required("Certificate name is required")
    //   .matches(charactersWithSpaces, "Only characters allowed"),
    // companyName: Yup.string()
    //   .required("Company name is required")
    //   .matches(charactersWithSpaces, "Only characters allowed"),
    issueDate: Yup.date().required("Issue date is required"),
    email: Yup.string().required("Email is required").email("Invalid email"),
    mobileNumber: Yup.string()
      .required("Mobile number is required")
      .test(
        "isValidPhone",
        "Invalid phone number",
        (v) => v && isValidPhoneNumber(v)
      ),
  });

  const simpleCertificateSchema = Yup.object({
    recipientName: Yup.string()
      .required("Recipient name is required")
      .matches(charactersWithSpaces, "Only characters allowed"),
    startDate: Yup.date().required("Start date is required"),
    endDate: Yup.date()
      .required("End date is required")
      .min(Yup.ref("startDate"), "End date must be after start date"),
    issueDate: Yup.date().required("Issue date is required"),
    email: Yup.string().required("Email is required").email("Invalid email"),
    mobileNumber: Yup.string()
      .required("Mobile number is required")
      .test(
        "isValidPhone",
        "Invalid phone number",
        (v) => v && isValidPhoneNumber(v)
      ),
  });

  const courseTrainingSchema = Yup.object({
    recipientName: Yup.string()
      .required("Recipient name is required")
      .matches(charactersWithSpaces, "Only characters allowed"),
    // certificateName: Yup.string()
    //   .required("Certificate name is required")
    //   .matches(charactersWithSpaces, "Only characters allowed"),
    // companyName: Yup.string()
    //   .required("Company name is required")
    //   .matches(charactersWithSpaces, "Only characters allowed"),
    courseName: Yup.string()
      .required("Course/Program name is required")
      .matches(charactersWithSpaces, "Only characters allowed"),
    issueDate: Yup.date().required("Issue date is required"),
    email: Yup.string().required("Email is required").email("Invalid email"),
    mobileNumber: Yup.string()
      .required("Mobile number is required")
      .test(
        "isValidPhone",
        "Invalid phone number",
        (v) => v && isValidPhoneNumber(v)
      ),
  });

  const schemas = {
    internship: internshipSchema,
    appreciation: appreciationAchievementSchema,
    achievement: appreciationAchievementSchema,
    hackathon_winner: hackathonSchema,
    hackathon_participation: hackathonSchema,
    most_valuable_person: simpleCertificateSchema,
    best_team: bestTeamSchema,
    leaders_choice: simpleCertificateSchema,
    great_work: simpleCertificateSchema,
    star_of_the_month: simpleCertificateSchema,
    star_of_the_quarter: simpleCertificateSchema,
    star_performer: simpleCertificateSchema,
    course_completion: courseTrainingSchema,
    training_completion: courseTrainingSchema,
  };

  const currentSchema =
    schemas[selectedCertificateType] || simpleCertificateSchema;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: certificateData,
    validationSchema: currentSchema,
    onSubmit: (values) => {
      console.log("CertificateForm submitted:", values);
      onSubmit({
        certificateData: {
          ...values,
          certificateType: selectedCertificateType,
          duration: values.duration ? Number(values.duration) : undefined,
        },
        certificateType: selectedCertificateType,
      });
    },
  });

  useEffect(() => {
    if (
      selectedCertificateType === "internship" &&
      formik.values.startDate &&
      formik.values.endDate
    ) {
      const start = new Date(formik.values.startDate);
      const end = new Date(formik.values.endDate);
      if (end >= start) {
        const durationDays = Math.floor((end - start) / (1000 * 60 * 60 * 24));
        formik.setFieldValue("duration", durationDays);
        console.log("Calculated duration:", durationDays);
      } else {
        formik.setFieldValue("duration", "");
        console.log("Invalid date range: endDate is before startDate");
      }
    }
  }, [formik.values.startDate, formik.values.endDate, selectedCertificateType]);

  console.log("Formik values:", formik.values);

  const renderSharedFields = () => (
    <>
      <Col md={4} className="mb-3">
        <Label htmlFor="recipientName">Recipient Name *</Label>
        <Input
          id="recipientName"
          name="recipientName"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.recipientName}
          invalid={
            formik.touched.recipientName && !!formik.errors.recipientName
          }
        />
        {formik.touched.recipientName && formik.errors.recipientName && (
          <div className="invalid-feedback d-block">
            {formik.errors.recipientName}
          </div>
        )}
      </Col>

      <Col md={4} className="mb-3">
        <Label htmlFor="email">Email *</Label>
        <Input
          id="email"
          name="email"
          type="email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
          invalid={formik.touched.email && !!formik.errors.email}
        />
        {formik.touched.email && formik.errors.email && (
          <div className="invalid-feedback d-block">{formik.errors.email}</div>
        )}
      </Col>
      <Col md={4} className="mb-3">
        <Label htmlFor="mobileNumber">Mobile Number *</Label>
        <PhoneInput
          international
          defaultCountry="IN"
          id="mobileNumber"
          name="mobileNumber"
          className="form-control d-flex"
          onChange={(v) => formik.setFieldValue("mobileNumber", v || "")}
          onBlur={formik.handleBlur}
          value={formik.values.mobileNumber}
        />
        {formik.touched.mobileNumber && formik.errors.mobileNumber && (
          <div className="invalid-feedback d-block">
            {formik.errors.mobileNumber}
          </div>
        )}
      </Col>
      <Col md={4} className="mb-3">
        <Label htmlFor="issueDate">Issue Date *</Label>
        <Input
          id="issueDate"
          name="issueDate"
          type="date"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.issueDate}
          invalid={formik.touched.issueDate && !!formik.errors.issueDate}
        />
        {formik.touched.issueDate && formik.errors.issueDate && (
          <div className="invalid-feedback d-block">
            {formik.errors.issueDate}
          </div>
        )}
      </Col>
    </>
  );

  const renderInternshipFields = () => {
    console.log("Rendering Internship fields");
    const fieldMeta = [
      { key: "courseType", label: "Course Type" },
      { key: "startDate", label: "Start Date", type: "date" },
      { key: "endDate", label: "End Date", type: "date" },
      {
        key: "duration",
        label: "Duration (days)",
        type: "number",
        disabled: true,
      },
    ];

    return fieldMeta.map(({ key, label, type, disabled }) => (
      <Col md={4} key={key} className="mb-3">
        <Label htmlFor={key}>{label} *</Label>
        <Input
          id={key}
          name={key}
          type={type || "text"}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values[key]}
          invalid={formik.touched[key] && !!formik.errors[key]}
          disabled={disabled}
        />
        {formik.touched[key] && formik.errors[key] && (
          <div className="invalid-feedback d-block">{formik.errors[key]}</div>
        )}
      </Col>
    ));
  };

  const renderAppreciationAchievementFields = () => {
    console.log("Rendering Appreciation/Achievement fields");
    return (
      <Col md={4} className="mb-3">
        <Label htmlFor="dept">Department *</Label>
        <Input
          id="dept"
          name="dept"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.dept}
          invalid={formik.touched.dept && !!formik.errors.dept}
        />
        {formik.touched.dept && formik.errors.dept && (
          <div className="invalid-feedback d-block">{formik.errors.dept}</div>
        )}
      </Col>
    );
  };

  const renderHackathonFields = () => {
    console.log("Rendering Hackathon fields");
    return (
      <Col md={4} className="mb-3">
        <Label htmlFor="hackathonName">Hackathon Name *</Label>
        <Input
          id="hackathonName"
          name="hackathonName"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.hackathonName}
          invalid={
            formik.touched.hackathonName && !!formik.errors.hackathonName
          }
        />
        {formik.touched.hackathonName && formik.errors.hackathonName && (
          <div className="invalid-feedback d-block">
            {formik.errors.hackathonName}
          </div>
        )}
      </Col>
    );
  };

  const renderBestTeamFields = () => {
    console.log("Rendering Best Team fields");
    return (
      <Col md={4} className="mb-3">
        <Label htmlFor="teamName">Team Name *</Label>
        <Input
          id="teamName"
          name="teamName"
          type="text"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.teamName}
          invalid={formik.touched.teamName && !!formik.errors.teamName}
        />
        {formik.touched.teamName && formik.errors.teamName && (
          <div className="invalid-feedback d-block">
            {formik.errors.teamName}
          </div>
        )}
      </Col>
    );
  };

  const renderCourseTrainingFields = () => {
    console.log("Rendering Course/Training fields");
    return (
      <>
        <Col md={4} className="mb-3">
          <Label htmlFor="courseName">
            {selectedCertificateType === "course_completion"
              ? "Course Name"
              : "Training Program Name"}{" "}
            *
          </Label>
          <Input
            id="courseName"
            name="courseName"
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.courseName}
            invalid={formik.touched.courseName && !!formik.errors.courseName}
          />
          {formik.touched.courseName && formik.errors.courseName && (
            <div className="invalid-feedback d-block">
              {formik.errors.courseName}
            </div>
          )}
        </Col>
        <Col md={4} className="mb-3">
          <Label htmlFor="startDate">Start Date *</Label>
          <Input
            id="startDate"
            name="startDate"
            type="date"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.startDate}
            invalid={formik.touched.startDate && !!formik.errors.startDate}
          />
          {formik.touched.startDate && formik.errors.startDate && (
            <div className="invalid-feedback d-block">
              {formik.errors.startDate}
            </div>
          )}
        </Col>
        <Col md={4} className="mb-3">
          <Label htmlFor="endDate">End Date *</Label>
          <Input
            id="endDate"
            name="endDate"
            type="date"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.endDate}
            invalid={formik.touched.endDate && !!formik.errors.endDate}
          />
          {formik.touched.endDate && formik.errors.endDate && (
            <div className="invalid-feedback d-block">
              {formik.errors.endDate}
            </div>
          )}
        </Col>
      </>
    );
  };

  const renderMvpGreatWorkFields = () => {
    console.log("Rendering MVP/Great Work fields");
    return (
      <>
        <Col md={4} className="mb-3">
          <Label htmlFor="startDate">Start Date *</Label>
          <Input
            id="startDate"
            name="startDate"
            type="date"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.startDate}
            invalid={formik.touched.startDate && !!formik.errors.startDate}
          />
          {formik.touched.startDate && formik.errors.startDate && (
            <div className="invalid-feedback d-block">
              {formik.errors.startDate}
            </div>
          )}
        </Col>
        <Col md={4} className="mb-3">
          <Label htmlFor="endDate">End Date *</Label>
          <Input
            id="endDate"
            name="endDate"
            type="date"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.endDate}
            invalid={formik.touched.endDate && !!formik.errors.endDate}
          />
          {formik.touched.endDate && formik.errors.endDate && (
            <div className="invalid-feedback d-block">
              {formik.errors.endDate}
            </div>
          )}
        </Col>
      </>
    );
  };

  const renderPeriodFields = () => {
    return (
      <>
        <Col md={4} className="mb-3">
          <Label htmlFor="startDate">Start Date *</Label>
          <Input
            id="startDate"
            name="startDate"
            type="date"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.startDate}
            invalid={formik.touched.startDate && !!formik.errors.startDate}
          />
          {formik.touched.startDate && formik.errors.startDate && (
            <div className="invalid-feedback d-block">
              {formik.errors.startDate}
            </div>
          )}
        </Col>
        <Col md={4} className="mb-3">
          <Label htmlFor="endDate">End Date *</Label>
          <Input
            id="endDate"
            name="endDate"
            type="date"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.endDate}
            invalid={formik.touched.endDate && !!formik.errors.endDate}
          />
          {formik.touched.endDate && formik.errors.endDate && (
            <div className="invalid-feedback d-block">
              {formik.errors.endDate}
            </div>
          )}
        </Col>
      </>
    );
  };

  const renderFormFields = () => {
    switch (selectedCertificateType) {
      case "internship":
        return renderInternshipFields();
      case "appreciation":
      case "achievement":
        return renderAppreciationAchievementFields();
      case "hackathon_winner":
      case "hackathon_participation":
        return renderHackathonFields();
      case "best_team":
        return renderBestTeamFields();
      case "course_completion":
      case "training_completion":
        return renderCourseTrainingFields();
      case "star_of_the_month":
      case "star_of_the_quarter":
      case "star_performer":
        return renderPeriodFields();
      case "most_valuable_person":
      case "leaders_choice":
      case "great_work":
        return renderMvpGreatWorkFields();
      default:
        return null;
    }
  };

  return (
    <Row className="p-4">
      <Col>
        <Card>
          <CardBody>
            <Form
              id="certificateForm"
              onSubmit={formik.handleSubmit}
              className="row g-3"
            >
              {renderSharedFields()}
              {renderFormFields()}
              <Col md={12} className="text-end">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={formik.isSubmitting}
                >
                  {certificateId
                    ? "Update and Preview Certificate"
                    : "Generate Certificate"}
                </button>
              </Col>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default CertificateForm;
